export default "__VITE_ASSET__D2pTv0Fy__"